import { render, staticRenderFns } from "./SectionSpaces.vue?vue&type=template&id=242bc746&scoped=true"
import script from "./SectionSpaces.vue?vue&type=script&lang=ts"
export * from "./SectionSpaces.vue?vue&type=script&lang=ts"
import style0 from "./SectionSpaces.vue?vue&type=style&index=0&id=242bc746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242bc746",
  null
  
)

export default component.exports